/**
 * Per-vizType shelf configuration. Each entry lists the field shelves to render
 * (in order) for that visual type. Adding a new viz type with custom shelf labels
 * is now a single line addition here, instead of a switch case.
 *
 * `kind` is one of:
 *   - 'row'    → row dimensions (X-axis / category)
 *   - 'col'    → column / series dimension
 *   - 'val'    → measures (values)
 *   - 'colorval' → a measure that drives color (e.g. word-cloud gradient)
 *   - 'filter' → slicer filters
 *
 * `label` is the human-readable shelf label.
 *
 * Visual types not listed fall through to the DEFAULT_SHELVES.
 */
export const SHELF_CONFIG_BY_VIZ_TYPE = {
  table:      [['row', 'Rows'], ['col', 'Columns'], ['val', 'Values'], ['filter']],
  pivot:      [['row', 'Row Fields'], ['col', 'Column Fields'], ['val', 'Values'], ['filter']],
  bar_chart:  [['row', 'Category (X-Axis)'], ['col', 'Color / Series'], ['val', 'Values (Y-Axis)'], ['filter']],
  line_chart: [['row', 'X-Axis'], ['col', 'Color / Series'], ['val', 'Y-Axis Values'], ['filter']],
  area_chart: [['row', 'X-Axis'], ['col', 'Color / Series'], ['val', 'Y-Axis Values'], ['filter']],
  pie_chart:  [['row', 'Slices (Category)'], ['val', 'Size (Value)'], ['filter']],
  scatter:    [['val', 'X & Y Measures'], ['row', 'Color / Group'], ['filter']],
  combo:      [['row', 'Category (X-Axis)'], ['val', 'Bar & Line Values'], ['filter']],
  gauge:      [['val', 'Gauge Value'], ['filter']],
  funnel:     [['row', 'Stages'], ['val', 'Stage Value'], ['filter']],
  waterfall:  [['row', 'Category (X-Axis)'], ['val', 'Change Value'], ['filter']],
  treemap:    [['row', 'Category'], ['val', 'Size Value'], ['filter']],
  wordcloud:  [['row', 'Words (Text)'], ['val', 'Size (Measure)'], ['colorval', 'Color (Measure)'], ['filter']],
  heatmap:    [['row', 'Row & Column Dimensions'], ['val', 'Color Intensity'], ['filter']],
  geo_map:    [['row', 'Location (State)'], ['val', 'Map Value'], ['filter']],
  radar:            [['row', 'Categories (Axes)'], ['val', 'Measures'], ['filter']],
  calendar_heatmap: [['row', 'Date'], ['val', 'Daily Value'], ['filter']],
  gantt:            [['row', 'Task'], ['val', 'Start & End'], ['filter']],
};

export const DEFAULT_SHELVES = [['row', 'Rows'], ['col', 'Columns'], ['val', 'Values'], ['filter']];

export function getShelvesForVizType(vizType) {
  return SHELF_CONFIG_BY_VIZ_TYPE[vizType] || DEFAULT_SHELVES;
}
